import { InjectionToken, Provider } from '@angular/core';
import { map, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { State } from './core.reducer';
import {
  selectAppReady,
  selectBreakpoint,
  selectElevatorIndex,
  selectElevatorRatio,
  selectPreferences,
} from './core.selectors';
import {
  GeolocalisationResponse,
  LunePreferences,
  Translation,
} from '@icilalune/types';
import { Breakpoint } from '@icilalune/utils/responsive';
import { UI_BREAKPOINT } from '@icilalune/ui/tokens';
import {
  ELEVATOR_FEATURE_BREAKPOINT,
  ELEVATOR_GEO_LOC_PREF,
} from '@icilalune/elevator-feature/tokens';
import { LIST_BREAKPOINT } from '@icilalune/list-feature/tokens';

export const APP_READY = new InjectionToken<Observable<boolean>>('APP_READY');

export const BREAKPOINT = new InjectionToken<Observable<Breakpoint>>(
  'BREAKPOINT'
);

export const ELEVATOR_INDEX = new InjectionToken<Observable<number>>(
  'ELEVATOR_INDEX'
);

export const ELEVATOR_RATIO = new InjectionToken<Observable<number>>(
  'ELEVATOR_RATIO'
);

export const LANGUAGES_MENU = new InjectionToken<Translation[]>(
  'LANGUAGES_MENU'
);

export const CORE_STATE_BACKEND_URL = new InjectionToken<string>(
  'CORE_STATE_BACKEND_URL'
);

export const PREFERENCES = new InjectionToken<string>('PREFERENCES');

export const PREFERENCES_GEO_LOC = new InjectionToken<GeolocalisationResponse>(
  'PREFERENCES_GEO_LOC'
);

export const CORE_PROVIDERS: Provider[] = [
  {
    provide: APP_READY,
    deps: [Store],
    useFactory: (store: Store<State>) => {
      return store.pipe(select(selectAppReady));
    },
  },
  {
    provide: BREAKPOINT,
    deps: [Store],
    useFactory: (store: Store<State>) => {
      return store.pipe(select(selectBreakpoint));
    },
  },
  {
    provide: UI_BREAKPOINT,
    deps: [BREAKPOINT],
    useFactory: (breakpoint$) => {
      return breakpoint$;
    },
  },
  {
    provide: ELEVATOR_FEATURE_BREAKPOINT,
    deps: [BREAKPOINT],
    useFactory: (breakpoint$) => {
      return breakpoint$;
    },
  },
  {
    provide: LIST_BREAKPOINT,
    deps: [BREAKPOINT],
    useFactory: (breakpoint$) => {
      return breakpoint$;
    },
  },
  {
    provide: ELEVATOR_INDEX,
    deps: [Store],
    useFactory: (store: Store<State>) => {
      return store.pipe(select(selectElevatorIndex));
    },
  },
  {
    provide: ELEVATOR_RATIO,
    deps: [Store],
    useFactory: (store: Store<State>) => {
      return store.pipe(select(selectElevatorRatio));
    },
  },
  /*{
    provide: LANGUAGES_MENU,
    deps: [ROUTED_NODE, TranslocoService],
    useFactory: (
      routedNode$: Observable<DrupalNode>,
      translocoService: TranslocoService
    ) => {
      return combineLatest([routedNode$, translocoService.langChanges$]).pipe(
        filter(([routedNode, language]) => !!routedNode),
        map(([routedNode, language]) => {
          const translations: Translations | undefined =
            routedNode.translations;
          const activeLang: string | undefined = language.split('-').shift();
          if (translations) {
            const languagesMenu = Object.keys(translations)
              .filter((key) => key !== activeLang)
              .map((key) => translations[key]);
            return languagesMenu;
          }
          return [];
        })
      );
    },
  },*/
  {
    provide: PREFERENCES,
    deps: [Store],
    useFactory: (store: Store<State>) => {
      return store.pipe(select(selectPreferences));
    },
  },
  {
    provide: PREFERENCES_GEO_LOC,
    deps: [PREFERENCES],
    useFactory: (preferences$: Observable<LunePreferences>) => {
      return preferences$.pipe(map((preferences) => preferences?.localizeMe));
    },
  },
  {
    provide: ELEVATOR_GEO_LOC_PREF,
    deps: [PREFERENCES_GEO_LOC],
    useFactory: (geoLocPrefs$) => {
      return geoLocPrefs$;
    },
  },
];
